import { createSignal } from '@verclam/pulsar';

/** `null` when no deletion is pending confirmation; otherwise the id of the user to confirm. */
const userToDeleteSignal = createSignal<number | null>(null);

export const setUserToDelete = (userId: number | null): void => {
	userToDeleteSignal.value = userId;
};

export default userToDeleteSignal;
